<template>
  <b-card>
    <FormBuilder
      label="Kategori Utama"
      update
      :data="$store.state.rootCategory.detailData"
      :fields="fields"
      :loading-detail="$store.state.rootCategory.loadingDetail"
      :loading-submit="$store.state.rootCategory.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/root-category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('rootCategory/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('rootCategory/update', { id, data })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('rootCategory/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
